import { render } from "./stat_fr.vue?vue&type=template&id=6cd604dc"
import script from "./stat_fr.vue?vue&type=script&lang=js"
export * from "./stat_fr.vue?vue&type=script&lang=js"

import "./stat_fr.vue?vue&type=style&index=0&id=6cd604dc&lang=css"

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__